// Prefixes rather than the payment method: method names are configured
// differently on each environment, a payer's number is not.
const ORANGE_CAMEROON_REGEX =
  /^(?:237)?(?:640|655|656|657|658|659|686|687|688|689|69[0-9])\d{6}$/;

const MTN_CAMEROON_REGEX =
  /^(?:237)?(?:650|651|652|653|654|67[0-9]|680|681|682|683)\d{6}$/;

// Returns a translation key, so the caller renders it in the payer's language.
const getInstructionByPaymentProvider = (phoneNumber?: string): string => {
  const digits = (phoneNumber ?? "").replace(/\D/g, "");

  if (ORANGE_CAMEROON_REGEX.test(digits)) return "stepper_3.instruction_orange";
  if (MTN_CAMEROON_REGEX.test(digits)) return "stepper_3.instruction_mtn";
  return "stepper_3.instruction_generic";
};

export default getInstructionByPaymentProvider;
